// @mui/icons-material
import PersonAdd from '@mui/icons-material/PersonAdd';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LockOpen from '@mui/icons-material/LockOpen';

export const routes = [
  {
    path: '/auth/inscription/',
    name: "S'inscrire",
    short: "S'inscrire",
    mini: 'IN',
    icon: PersonAdd,
  },
  {
    path: '/auth/connexion',
    name: 'Se connecter',
    short: 'Se connecter',
    mini: 'CO',
    icon: AccountCircle,
  },
  {
    path: '/auth/mot-de-passe',
    name: 'Mot de passe oublié ?',
    short: 'Mdp oublié ?',
    mini: 'MDP',
    icon: LockOpen,
  },
  {
    path: '/auth/',
    pathTo: '/auth/connexion',
    name: "S'inscrire",
  },
];
